export const isABN = (abn?: String) => /^\d{11}$/.test(abn);
export const isACN = (abn?: String) => /^\d{9}$/.test(abn);
export const isBSB = (abn?: String) => /^\d{6}$/.test(abn);
export const isNZBN = (abn?: String) => /^\d{13}$/.test(abn);

export const isBlank = (str?: string): boolean => !str || /^\s*$/.test(str);
export const isEmpty = (str?: string): boolean => !str || str.length === 0;
export const isEmail = (str?: string): boolean =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    str
  );
export const isFilename = (str?: string) =>
  /^[^\\/:*?"<>|]+$/.test(str) &&
  !/^\./.test(str) &&
  !/^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i.test(str);
export const isUUID = (str?: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);

export default {
  isABN,
  isACN,
  isBSB,
  isNZBN,

  isBlank,
  isEmpty,
  isEmail,
  isFilename,
  isUUID
};
